import script from "./ProfileEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileEdit.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileEdit.vue?vue&type=style&index=0&id=56c31c1d&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56c31c1d"]])

export default __exports__